import React, { useState, useEffect } from "react";
import {
  FiHome,
  FiFileText,
  FiPieChart,
  FiLogOut,
  FiChevronsLeft,
  FiChevronsRight,
  FiAperture,
  FiUser,
  FiUploadCloud,
} from "react-icons/fi";

import logoImage from "../../images/logo_ylhq.png";

import {
  Sidebar,
  SidebarHeader,
  SidebarLogo,
  SidebarCollapseButton,
  SidebarNav,
  SidebarLink,
  SidebarFooter,
  SidebarUser,
  SidebarUserAvatar,
  SidebarUserInfo,
  SidebarUserName,
  SidebarUserRole,
  SidebarLogoutButton,
} from "../styles/Layoutstyle";

const DashboardSidebar = ({
  isOpen,
  activeView,
  onNavigation,
  onLogout,
  username,
  userRole,
  isSidebarCollapsed,
  handleSidebarCollapseToggle,
  isDarkMode,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const showCollapsed = !isMobile && isSidebarCollapsed;

  return (
    <Sidebar
      isOpen={isOpen}
      isCollapsed={showCollapsed}
      isDarkMode={isDarkMode}
    >
      <SidebarHeader isCollapsed={showCollapsed} isDarkMode={isDarkMode}>
        {!isMobile &&
          (showCollapsed ? (
            <SidebarCollapseButton
              aria-label="Expand sidebar"
              onClick={() => handleSidebarCollapseToggle()}
              isDarkMode={isDarkMode}
            >
              <FiChevronsRight />
            </SidebarCollapseButton>
          ) : (
            <>
              <SidebarLogo src={logoImage} alt="Yellow Letter HQ Logo" />
              <SidebarCollapseButton
                aria-label="Collapse sidebar"
                onClick={() => handleSidebarCollapseToggle()}
                isDarkMode={isDarkMode}
              >
                <FiChevronsLeft />
              </SidebarCollapseButton>
            </>
          ))}
        {isMobile && (
          <SidebarLogo src={logoImage} alt="Yellow Letter HQ Logo" />
        )}
      </SidebarHeader>

      <SidebarNav>
        <SidebarLink
          isCollapsed={showCollapsed}
          active={activeView === "dashboard"}
          onClick={() => onNavigation("dashboard")}
          isDarkMode={isDarkMode}
        >
          <FiHome />
          {(!showCollapsed || isMobile) && "Dashboard"}
        </SidebarLink>
        <SidebarLink
          isCollapsed={showCollapsed}
          active={activeView === "orders"}
          onClick={() => onNavigation("orders")}
          isDarkMode={isDarkMode}
        >
          <FiFileText />
          {(!showCollapsed || isMobile) && "Orders"}
        </SidebarLink>
        <SidebarLink
          isCollapsed={showCollapsed}
          active={activeView === "analytics"}
          onClick={() => onNavigation("analytics")}
          isDarkMode={isDarkMode}
        >
          <FiPieChart />
          {(!showCollapsed || isMobile) && "Analytics"}
        </SidebarLink>
        <SidebarLink
          isCollapsed={showCollapsed}
          active={activeView === "accuzip"}
          onClick={() => onNavigation("accuzip")}
          isDarkMode={isDarkMode}
        >
          <FiAperture />
          {(!showCollapsed || isMobile) && "Accuzip Queue"}
        </SidebarLink>
        <SidebarLink
          isCollapsed={showCollapsed}
          active={activeView === "realflow"}
          onClick={() => onNavigation("realflow")}
          isDarkMode={isDarkMode}
        >
          <FiUploadCloud />
          {(!showCollapsed || isMobile) && "RealFlow CSVs"}
        </SidebarLink>
        {userRole === "admin" && (
          <SidebarLink
            isCollapsed={showCollapsed}
            active={activeView === "users"}
            onClick={() => onNavigation("users")}
            isDarkMode={isDarkMode}
          >
            <FiUser />
            {(!showCollapsed || isMobile) && "Users Management"}
          </SidebarLink>
        )}
      </SidebarNav>

      <SidebarFooter isDarkMode={isDarkMode}>
        <SidebarUser isCollapsed={showCollapsed}>
          <SidebarUserAvatar isCollapsed={showCollapsed}>
            {username?.charAt(0).toUpperCase()}
          </SidebarUserAvatar>
          <SidebarUserInfo isCollapsed={showCollapsed}>
            <SidebarUserName isDarkMode={isDarkMode}>
              {username}
            </SidebarUserName>
            <SidebarUserRole>{userRole}</SidebarUserRole>
          </SidebarUserInfo>
        </SidebarUser>
        <SidebarLogoutButton isCollapsed={showCollapsed} onClick={onLogout}>
          <FiLogOut />
          {(!showCollapsed || isMobile) && "Logout"}
        </SidebarLogoutButton>
      </SidebarFooter>
    </Sidebar>
  );
};

export default DashboardSidebar;
